import {GET_FAQ, GET_FAQ_CATEGORY} from 'store/constants'

export function getFaqCategory(values) {
  return {
    type: GET_FAQ_CATEGORY,
    payload: values,
  }
}
